/* eslint-disable import/no-extraneous-dependencies */
import { ActionType, createAction } from 'typesafe-actions';
import { VisibilityState } from './visibilityReducer';

export enum VisibilityActionTypes {
  BladeComplete = '[Visibility] Blade Complete',
  BladesUpdate = '[Visibility] Blades Update',
  BladeChangeFocus = '[Visibility] Blades Change Focus',
  BladeChangeDisplay = '[Visibility] Blades Change Display',
}

export const visibilityActions = {
  bladeComplete: createAction(VisibilityActionTypes.BladeComplete)<string>(),
  bladesUpdate: createAction(VisibilityActionTypes.BladesUpdate)<VisibilityState>(),
  bladeChangeFocus: createAction(VisibilityActionTypes.BladeChangeFocus)<string>(),
  bladeChangeDisplay: createAction(VisibilityActionTypes.BladeChangeDisplay)<string>(),
};

export type VisibilityAction = ActionType<typeof visibilityActions>;
